import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const PublicFooter = () => {
  return (
    <footer role="contentinfo" className="bg-secondary-950 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/brand/logo-96.png"
                alt=""
                className="h-9 w-9 rounded-full object-cover flex-shrink-0"
                loading="lazy"
                aria-hidden="true"
              />
              <span className="font-semibold">Second Story</span>
            </div>
            <p className="text-secondary-400 text-sm max-w-none">
              A Rhode Island nonprofit corporation empowering career transitions through
              technology education and mentorship.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-secondary-300 uppercase tracking-wide mb-4">
              Platform
            </h3>
            <ul className="space-y-2 text-secondary-400 text-sm" role="list">
              <li>
                <Link to="/learning" className="hover:text-white no-underline hover:no-underline transition-colors">
                  Learning Paths
                </Link>
              </li>
              <li>
                <Link to="/mentor" className="hover:text-white no-underline hover:no-underline transition-colors">
                  AI Mentor
                </Link>
              </li>
              <li>
                <Link to="/mentorship" className="hover:text-white no-underline hover:no-underline transition-colors">
                  Mentorship
                </Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-white no-underline hover:no-underline transition-colors">
                  Projects
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-secondary-300 uppercase tracking-wide mb-4">
              Organization
            </h3>
            <ul className="space-y-2 text-secondary-400 text-sm" role="list">
              <li>
                <Link to="/about" className="hover:text-white no-underline hover:no-underline transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="mailto:eHunter@straydog-secondstory.org"
                  className="hover:text-white no-underline hover:no-underline transition-colors"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/eric-petross/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white no-underline hover:no-underline transition-colors inline-flex items-center gap-1"
                >
                  LinkedIn
                  <ExternalLink className="h-3 w-3 opacity-60" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-secondary-300 uppercase tracking-wide mb-4">
              Legal
            </h3>
            <ul className="space-y-2 text-secondary-400 text-sm" role="list">
              <li>
                <Link to="/privacy" className="hover:text-white no-underline hover:no-underline transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white no-underline hover:no-underline transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/donate" className="hover:text-white no-underline hover:no-underline transition-colors">
                  Support Our Mission
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm text-secondary-400">
          <p>&copy; {new Date().getFullYear()} Second Story Initiative. All rights reserved.</p>
          <p className="text-secondary-500">
            RI Nonprofit &middot; EIN 42-2812566
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
